import { DisplaySettingFormSchemaValues } from 'src/features/systems/utils/displaySettingFormSchema';
import {
    FormFieldBlockName,
    FormFieldBlockSeparator,
    FormFieldBlockTitle,
} from 'src/registry/components/blocks/FormFieldBlock';
import { useIntl } from 'react-intl';
import { displaySettingsMessages } from 'src/features/systems/utils/displaySettingsMessages';
import InputFormField from 'src/registry/components/forms/InputFormField';
import { UseFormReturn } from 'react-hook-form';

type SettingCode = keyof DisplaySettingFormSchemaValues;

type DisplaySettingCodeInputsProps = {
    form: UseFormReturn<DisplaySettingFormSchemaValues>;
    code: SettingCode;
    sectionTitle: string;
};

const DisplaySettingCodeInputs = ({ code, sectionTitle, form }: DisplaySettingCodeInputsProps) => {
    const { formatMessage } = useIntl();

    return (
        <>
            <FormFieldBlockTitle>
                <FormFieldBlockName className="flex flex-row gap-1">{sectionTitle}</FormFieldBlockName>
            </FormFieldBlockTitle>
            <InputFormField
                form={form}
                name={`${code}.title` as const}
                label={formatMessage(displaySettingsMessages.title)}
                required={false}
            />
            <InputFormField
                form={form}
                name={`${code}.subtitle` as const}
                label={formatMessage(displaySettingsMessages.subtitle)}
                required={false}
            />
            <InputFormField
                form={form}
                name={`${code}.title_color` as const}
                label={formatMessage(displaySettingsMessages.titleColor)}
                required={false}
            />
            <InputFormField
                form={form}
                name={`${code}.subtitle_color` as const}
                label={formatMessage(displaySettingsMessages.subtitleColor)}
                required={false}
            />
            <FormFieldBlockSeparator />
        </>
    );
};

export default DisplaySettingCodeInputs;
